import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async,
  __objRest
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/cards/userList.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getUserDigitalCards = (_a) => __async(void 0, null, function* () {
  var _b = _a, { locale } = _b, props = __objRest(_b, ["locale"]);
  try {
    const lang = getLocaleOnly(locale);
    const search = new URLSearchParams();
    search.set("lang", lang);
    for (const key in props) {
      const val = props[key];
      if (val) {
        search.set(key, val.toString());
      }
    }
    const data = yield fetchClient({
      url: `/fec/user-cards?${search.toString()}`
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getUserDigitalCardsException"
    });
  }
});

export {
  getUserDigitalCards
};
//# sourceMappingURL=chunk-WJEYPIHE.mjs.map